import React from 'react';
import PropTypes from 'prop-types';

export function createGroup(WrappedComponent, groupName, idPath, idSubPath) {
    return class IdMixin extends React.Component {
        state = {
            idPath: null,
            idPathSub: null,
            subscriptions: {},
            error: null
        };

        static contextTypes = {
            t: PropTypes.func.isRequired,
            p: PropTypes.object.isRequired
        }

        static childContextTypes = {
            groupName: PropTypes.string,
            activePath: PropTypes.string,
            isDetails: PropTypes.bool,
            isEdit: PropTypes.bool
        }

        getChildContext() {
            return {
                groupName: groupName,
                activePath: this.props.activePath,
                isDetails: this.props.isDetails,
                isEdit: this.props.isEdit
            };
        }

        _isMounted = false;

        unsubscribeAll = () => {
            if (this.state.idPathSub) {
                this.context.p.unsubscribeDS(this.idPathSubChanged, this.state.idPathSub);
            }
        }

        subscribe(idPath) {
            this.unsubscribeAll();
            let idPathSub = this.context.p.subscribeDS(idPath, this.idPathSubChanged);

            this.setState({subscriptions: {}, idPathSub: idPathSub, idPath: idPath});

            this.idPathSubChanged(this.context.p.getPath(idPath));
        }

        idPathSubChanged = (value, p1, p2) => {
            if (!this._isMounted) {
                return;
            }
            console.log("changed", value, p1, p2);
            if (value === 0 || value === null || value === undefined) {
                this.setState({error: "notfound"});
                return;
            }
            if (!value[idSubPath]) {
                return;
            }

            const s = this.state.subscriptions;
            const oldIds = [];
            for (let oldId in s) {
                oldIds.push(oldId);
            }
            const newSubs = {};

            for (let idx in value[idSubPath]) {
                let groupId = value[idSubPath][idx];
                if (!s[groupId]) {
                    // A new group, add it
                    let path;

                    // See if it is a relative path (to group/) or absolute
                    if (typeof groupId === "number" || groupId.indexOf("/") === -1) {
                        path = "group/" + groupId;
                    } else {
                        path = groupId;
                    }
                    newSubs[groupId] = {
                        key: path,
                        groupName,
                        path,
                        parentPath: idPath,
                        ...this.props
                    }
                } else {
                    // If we knew about this group already, copy the existing instance
                    newSubs[groupId] = s[groupId];
                }
            }

            this.setState({subscriptions: newSubs});
        }

        subChanged = () => {

        }

        componentDidMount() {
            this._isMounted = true;
            if (idPath !== this.state.idPath) {
                this.subscribe(idPath);
            }
        }

        // componentDidUpdate(prevProps) {
        //     console.log("IdMixin componentDidUpdate", prevProps.idPath, this.props.idPath);
        //     if (this.props.idPath !== this.state.idPath) {
        //         this.subscribe(this.props.idPath);
        //     }
        // }

        render() {
            let orderedGroups = [];
            let renderCount = 0;

            // Map group ids to names
            const groupIdToNames = {};
            const orderedGroupIds = [];

            if (!this.context.p.DS.group) {
                return null;
            }

            for (const gId in this.state.subscriptions) {
                const name = this.context.p.DS.group[gId]?.name;
                groupIdToNames[gId] = name;
                orderedGroupIds.push(gId);
            }

            orderedGroupIds.sort((id1, id2) => {
                if (groupIdToNames[id1] == groupIdToNames[id2]) {
                    return 0;
                }
                return groupIdToNames[id1] > groupIdToNames[id2] ? 1 : -1;
            });

            for (let groupId of orderedGroupIds) {
                const item = this.state.subscriptions[groupId];
                orderedGroups.push(
                    <WrappedComponent {...item} />
                );
                let path;
                if (typeof groupId === "number" || groupId.indexOf("/") === -1) {
                    path = "group/" + groupId;
                } else {
                    path = groupId;
                }
                if (path === this.props.activePath && this.props.activeDetails) {
                    orderedGroups.push(this.props.activeDetails);
                }
                renderCount++;
            }

            if (renderCount == 0) {
                orderedGroups = (
                    <div className="empty">
                        <div className="empty-icon">
                            <i className="icon icon-flag"></i>
                        </div>
                        <p className="empty-title h5">{ this.context.t("groups.no__are_available", {groupType: this.context.t(groupName)}) }</p>
                    </div>
                );
            }
            return orderedGroups;
        }

        componentWillUnmount() {
            this._isMounted = false;
            console.log("IdMixin componentWillUnmount");
            this.unsubscribeAll();
        }
    }
}

// IdMixin.propTypes = {
//     groupName: PropTypes.string.isRequired,
//     idPath: PropTypes.string.isRequired,
// }